import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import { Observer } from 'mobx-react';
import Nav from './Nav';
import { useRootStore } from '../../stores/BridgeProvider';

const SettingsAgnosticRoute = ({
  component: PassedComponent,
  children,
  ...rest
}) => {
  return (
    <Observer
      render={() => {
        const { authStore } = useRootStore();
        const { isAuthenticated, logout } = authStore;
        return (
          <Route
            {...rest}
            render={props => {
              if (!isAuthenticated)
                return (
                  <Redirect
                    to={{ pathname: '/login', state: { from: props.location } }}
                  />
                );
              return (
                <React.Fragment>
                  <IdleTimer onIdle={logout} timeout={1000 * 60 * 30} />
                  <Nav {...props} />
                  {PassedComponent && <PassedComponent {...props} />}
                  {children}
                </React.Fragment>
              );
            }}
          />
        );
      }}
    />
  );
};

export default SettingsAgnosticRoute;
